export const getEscapeComment = text => {
    return text.replace(
        /[&<>'"]/g,
        tag =>
            ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                // eslint-disable-next-line
                "'": '&#39;',
                '"': '&quot;',
            }[tag] || tag),
    );
};

export const getBrComment = (text, ellipsis) => {
    const reg = new RegExp(`((\n)|(\\\\n))+${ellipsis}$`, 'g');

    return text.replace(reg, '<br />').replace(/(\n)+/g, '<br />');
};
